import {
  BolusState,
  BolusType,
} from "@tandemdiabetes/sugarmate-api-react-client"
import type { BolusActivity } from "@tandemdiabetes/sugarmate-api-react-client"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"
import styles from "./ActivityTitle.module.scss"
import { usePolyglot } from "src/contexts"
import { serverInsulinToUserInsulin } from "src/utils"

interface Props extends ComponentPropsWithoutRef<"div"> {
  activity: BolusActivity;
}

export const BolusActivityTitle = forwardRef<HTMLDivElement, Props>(
  function BolusActivityTitle(props: Props, ref: Ref<HTMLDivElement>) {
    const {
      activity, ...htmlDivProps
    } = props

    const polyglot = usePolyglot()

    const insulinTotal = polyglot.t(
      "unit.num_units_abbreviated",
      {
        units: serverInsulinToUserInsulin(
          activity.state === BolusState.InProgress
            ? (activity.insulin_total_requested ?? activity.insulin_total_delivered ?? 0)
            : (activity.insulin_total_delivered ?? 0),
        ).toLocaleString(polyglot.locale()),
      },
    )

    const bolusType = polyglot.t(`bolus_type.${activity.bolus_type ?? BolusType.Food}`)

    const title = polyglot.t(
      "components.activity_summary.title.bolus",
      {
        insulinTotal,
        bolusType,
      },
    )

    return (
      <div
        {...htmlDivProps}
        ref={ref}
        className={`${htmlDivProps.className ?? ""} ${styles.bolusTitle}`}
      >
        {title}
      </div>
    )
  },
)
